
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojammukashmircabs() {



    const cardData =
    {
        keyword: 'Pune to Jammu Kashmir Cabs ',
        heading: 'Platinum24 Cabs: Pune to Jammu Kashmir Cabs',
        headingDescription: ' Platinum24 Cabs offers trusted Pune to Jammu & Kashmir cab services, designed for pilgrims, tourists, and families seeking a long-distance travel solution. Whether you’re planning a serene trip to Srinagar’s Dal Lake, visiting Vaishno Devi Temple in Katra, exploring Gulmarg’s snow-covered peaks, or experiencing Pahalgam’s valleys, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey. With professional chauffeurs, punctual pickups, and transparent pricing, we make your travel stress-free and enjoyable. From one-way drops to customized round packages, Platinum24 Cabs guarantees reliable service and a memorable Pune to Jammu & Kashmir travel experience.',

        top: 'Top Places to Visit in Jammu Kashmir with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Srinagar & Dal Lake",
    "description": "Srinagar, the summer capital of Jammu & Kashmir, is world-famous for its Dal Lake. Shikara rides, floating markets, and houseboat stays make it magical. The Mughal gardens—Shalimar Bagh, Nishat Bagh, and Chashme Shahi—enhance its charm. Tulip Garden blooms in spring with vibrant colors. The snow-covered Zabarwan range forms a breathtaking backdrop. Srinagar is J&K’s serene paradise on water."
  },
  {
    "title": "Gulmarg",
    "description": "Gulmarg, the Meadow of Flowers, is a premier skiing and adventure destination. The Gulmarg Gondola, one of the world’s highest cable cars, offers panoramic views. In summer, meadows are covered with wildflowers, while winters turn it into a ski haven. Golfing at the world’s highest green golf course adds to its charm. Gulmarg is J&K’s adventure and scenic gem."
  },
  {
    "title": "Pahalgam",
    "description": "Pahalgam, the Valley of Shepherds, is known for its stunning landscapes and as the starting point of the Amarnath Yatra. Lidder River adds beauty with rafting and fishing opportunities. Aru and Betaab Valleys nearby are picturesque getaways. Snow-clad peaks surround the region, making it popular for trekking. Pahalgam is J&K’s breathtaking mountain retreat."
  },
  {
    "title": "Sonmarg",
    "description": "Sonmarg, the Meadow of Gold, lies in the Himalayas at 9,000 feet. Surrounded by glaciers, alpine lakes, and snow peaks, it is a paradise for nature lovers. Trekking routes lead to Thajiwas Glacier and high-altitude passes. In summer, meadows glow with flowers. Horse riding and camping are popular activities. Sonmarg is J&K’s alpine wonderland."
  },
  {
    "title": "Vaishno Devi Temple, Katra",
    "description": "Vaishno Devi Temple, located near Katra, is one of India’s most revered pilgrimage sites. Devotees trek 13 km uphill to seek blessings of Mata Vaishno Devi. Helicopter services and ponies make the journey easier. Spiritual chants fill the air with devotion. The shrine attracts millions annually. Vaishno Devi is J&K’s divine spiritual beacon."
  },
  {
    "title": "Leh-Ladakh",
    "description": "Leh-Ladakh is a high-altitude desert region, famous for monasteries, Pangong Lake, and Nubra Valley. Visitors enjoy bike rides through Khardung La, one of the world’s highest motorable passes. Tibetan culture and Buddhist stupas add uniqueness. Adventure seekers love trekking, rafting, and camping. Stunning landscapes and starry skies make it unforgettable. Leh-Ladakh is J&K’s ultimate adventure paradise."
  },
  {
    "title": "Amarnath Cave",
    "description": "The Amarnath Cave, at an altitude of 12,756 feet, is one of Hinduism’s holiest shrines. A naturally formed ice Shiva Lingam attracts pilgrims from across the world. The annual Amarnath Yatra is a spiritual and challenging trek. Surrounded by glaciers, it is open only in summer. Devotees believe visiting here grants moksha. Amarnath is J&K’s sacred Himalayan shrine."
  },
  {
    "title": "Patnitop",
    "description": "Patnitop is a hill station near Jammu, offering panoramic views of the Shivalik range. It is famous for trekking, paragliding, and skiing in winter. Pine forests and meadows create a serene escape. Families enjoy picnics and nature walks. The calm atmosphere contrasts with the bustling plains. Patnitop is J&K’s peaceful mountain retreat."
  },
  {
    "title": "Mughal Road & Rajouri–Poonch",
    "description": "The Mughal Road, connecting Poonch and Rajouri with Srinagar, is a historic and scenic route. Travelers pass through Pir Panjal mountains, meadows, and apple orchards. Ancient forts and shrines along the way narrate history. It offers an alternative to the Jammu–Srinagar Highway. The region showcases unexplored beauty of J&K. Mughal Road is the state’s offbeat heritage trail."
  },
  {
    "title": "Dachigam National Park",
    "description": "Dachigam National Park, near Srinagar, is home to the endangered Hangul (Kashmiri stag). Spread over 140 sq km, it also shelters leopards, Himalayan black bears, and exotic birds. The park has trekking trails through alpine forests and grasslands. Wildlife photographers love its biodiversity. Best visited in spring and autumn, it blends nature with adventure. Dachigam is J&K’s pristine wildlife sanctuary."
  }
],


                     "services": [
    {
      "name": "Pune to Jammu Kashmir Cab",
      "description": "Embark on a breathtaking journey from Pune to Jammu Kashmir with our dedicated Pune to Jammu Kashmir Cab service, designed to provide a safe, comfortable, and memorable travel experience. Whether you’re visiting the serene valleys, religious shrines, or planning a business trip, our fleet of well-maintained cars offers spacious interiors, modern amenities, and smooth rides throughout this long-distance route. Professional drivers with in-depth knowledge of the terrain ensure timely pickups, optimal routes, and safe driving, allowing you to relax and enjoy the scenic vistas along the way."
    },
    {
      "name": "Pune to J&K Taxi Service",
      "description": "Our Pune to Jammu & Kashmir Taxi Service caters to travelers seeking reliable and convenient transportation options to the beautiful northern region of India. With a focus on safety and comfort, our taxis are equipped with air conditioning, GPS navigation, and ample luggage space. Whether traveling solo, with family, or in groups, our service is customizable to meet your specific needs, including one-way trips, round trips, and sightseeing detours. Transparent pricing, easy booking, and 24/7 customer support enhance your travel convenience."
    },
    {
      "name": "Book Pune to Jammu Cab",
      "description": "Secure your Pune to Jammu Cab effortlessly with our streamlined online booking system. Choose from a range of vehicle options that suit your budget and travel preferences, and get instant confirmation along with clear fare estimates. Our user-friendly platform supports flexible scheduling, special requests, and offers multiple payment methods for your convenience. Our customer support team is always ready to assist with any changes or inquiries, making your booking process seamless and stress-free."
    },
    {
      "name": "Book Pune to Srinagar Taxi",
      "description": "Plan your trip to the scenic city of Srinagar with our easy-to-use Pune to Srinagar Taxi booking service. Whether visiting for leisure or work, our taxis provide comfortable seating, reliable drivers, and safe rides along the picturesque routes. Book in advance or at short notice through our online platform or phone service, and enjoy transparent pricing with no hidden fees. We also offer customizable trip options including sightseeing stops and flexible drop-off locations."
    },
    {
      "name": "Pune to Kashmir Cab Booking",
      "description": "Our Pune to Kashmir Cab Booking service offers comprehensive travel solutions tailored to your itinerary and preferences. Whether you’re planning a family vacation, pilgrimage, or corporate travel, our cabs are equipped to handle long-distance journeys with ease. Enjoy a fleet of vehicles ranging from sedans to SUVs, all maintained for comfort and safety. With easy online booking, 24/7 customer support, and flexible cancellation policies, your travel planning becomes hassle-free and reliable."
    },
    {
      "name": "Pune to Jammu One Way Cab",
      "description": "Take advantage of our Pune to Jammu One Way Cab service, perfect for travelers who prefer a single-direction journey without the need to arrange return transport. This service offers competitive pricing, professional drivers, and well-maintained vehicles to ensure a comfortable and safe trip. Ideal for relocations, business travel, or personal visits, our one-way cabs provide flexibility without compromising on quality."
    },
    {
      "name": "Pune to Kashmir Taxi Fare",
      "description": "Get clear and upfront Pune to Kashmir Taxi Fare information, helping you budget your trip with confidence. Our fare structure is transparent and competitive, taking into account distance, vehicle type, tolls, and any additional services. Special discounts for early bookings, return trips, and group travel make our fares even more affordable. Reach out to our customer service team anytime for detailed quotes or customized pricing options tailored to your journey."
    },
    {
      "name": "Cab from Pune to Jammu Kashmir",
      "description": "Travel in comfort and style with our Cab service from Pune to Jammu Kashmir, offering a wide range of vehicles to suit all traveler needs. Our cabs are regularly sanitized and maintained to the highest standards, ensuring your safety and well-being. Experienced drivers familiar with northern routes will navigate you smoothly through highways and mountainous terrain, delivering a stress-free travel experience. Flexible booking, transparent pricing, and excellent customer service make us your trusted partner for this journey."
    },
    {
      "name": "Jammu to Pune Cab",
      "description": "Plan your return journey with our dependable Jammu to Pune Cab service, offering safe and comfortable rides back to Pune. Whether returning after business, holidays, or family visits, our professional drivers ensure punctual pickups and smooth navigation. Our vehicles come equipped with all necessary amenities for long-distance travel, and booking is simple with options for online or phone reservations. Enjoy competitive rates and 24/7 customer support throughout your trip."
    },
    {
      "name": "Pune to J&K Outstation Taxi",
      "description": "Our Pune to Jammu & Kashmir Outstation Taxi service specializes in long-distance travel, providing reliable and comfortable transportation for intercity journeys. Vehicles are selected for their comfort and durability, and drivers are trained for safe highway and mountainous terrain navigation. Flexible scheduling, stopover options, and transparent pricing make this service ideal for travelers seeking stress-free, dependable transportation to the region."
    },
    {
      "name": "Pune to Jammu Kashmir Car Hire",
      "description": "Rent a vehicle for your Pune to Jammu Kashmir trip with our flexible car hire service, offering both self-drive and chauffeur-driven options. Choose from sedans, SUVs, or luxury cars depending on your preferences and group size. Our cars are well-maintained, sanitized, and equipped with modern amenities to ensure safety and comfort. Whether for tourism, business, or family travel, our car hire service provides flexibility in terms of rental duration and itinerary customization."
    }
  ],
  "tableData": [
    ["Pune to Jammu Kashmir Cab", "Pune to J&K Taxi Service"],
    ["Book Pune to Jammu Cab", "Book Pune to Srinagar Taxi"],
    ["Pune to Kashmir Cab Booking", "Pune to Jammu One Way Cab"],
    ["Pune to Kashmir Taxi Fare", "Cab from Pune to Jammu Kashmir"],
    ["Jammu to Pune Cab", "Pune to J&K Outstation Taxi"],
    ["Pune to Jammu Kashmir Car Hire", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Jammu Kashmir Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab services from Pune to Jammu Kashmir, ensuring a smooth and safe travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Your Journey",
    "WhyChoosedescription": "Choose from sedans, SUVs, hatchbacks, and tempo travellers suitable for long-distance travel from Pune to Jammu Kashmir."
  },
  {
    "WhyChooseheading": "Sanitized and Clean Cabs for Passenger Safety",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized to provide a hygienic and safe environment throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Jammu Kashmir to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares including fuel, tolls, and driver allowances for a hassle-free Pune to Jammu Kashmir cab experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist you with Pune to Jammu Kashmir cab bookings and queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Your Convenience",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans tailored to your Pune to Jammu Kashmir travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Jammu Kashmir cab quickly and securely through our website or app with immediate confirmation."
  }
]


























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Pune to Jammu Kashmir cab services?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services from Pune to Jammu Kashmir with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Jammu Kashmir?',
        answer: 'You can book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Jammu Kashmir travel?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your travel needs and group size.',
    },
    {
        question: 'Is one-way cab service available from Pune to Jammu Kashmir?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Jammu Kashmir travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Jammu Kashmir long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Jammu Kashmir route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Jammu Kashmir?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Pune and Jammu Kashmir.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Jammu Kashmir cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Jammu Kashmir cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Jammu Kashmir cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Jammu Kashmir cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Jammu Kashmir cab services?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Arjun Singh',
        feedback: 'Platinum24 Cabs made my Pune to Jammu Kashmir trip smooth and comfortable. Highly recommend their services!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Gupta',
        feedback: 'Excellent cab service with professional drivers for my Pune to Jammu Kashmir journey.',
        rating: 5,
    },
];















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToJammuKashmirCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jammu Kashmir Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-jammu-kashmir-cab.jpg",
  "description": "Book Pune to Jammu Kashmir cab service with Platinum24 Cabs. Choose from reliable sedans, SUVs, and outstation taxis for one-way and round trips. Safe, comfortable, and available 24/7 for your travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-jammu-kashmir-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Jammu Kashmir Cab Service | Safe & Reliable Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Jammu Kashmir cab service with Platinum24 Cabs. Choose from reliable sedans, SUVs, and outstation taxis for one-way and round trips. Safe, comfortable, and available 24/7 for your travel needs."
  />
  <meta
    name="keywords"
    content="Pune to Jammu Kashmir Cab, Pune to J&K Taxi Service, Book Pune to Jammu Cab, Book Pune to Srinagar Taxi, Pune to Kashmir Cab Booking, Pune to Jammu One Way Cab, Pune to Kashmir Taxi Fare, Cab from Pune to Jammu Kashmir, Jammu to Pune Cab, Pune to J&K Outstation Taxi, Pune to Jammu Kashmir Car Hire"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJammuKashmirCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/110.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojammukashmircabs;